import React from 'react';
import { useLocation } from 'react-router-dom';
import Introduction from '../../pages/docs/Introduction';
import QuickStart from '../../pages/docs/QuickStart';
import ContractAddresses from '../../pages/docs/ContractAddresses';
import MavrkLocker from '../../pages/docs/MavrkLocker';
import TokenTrading from '../../pages/docs/TokenTrading';
import TokenLocker from '../../pages/docs/TokenLocker';
import BridgeOperations from '../../pages/docs/BridgeOperations';
import WalletManagement from '../../pages/docs/WalletManagement';
import TermsAndConditions from '../../pages/docs/TermsAndConditions';
import TydroLeveragedTrading from '../../pages/docs/TydroLeveragedTrading';

const DocsRouter: React.FC = () => {
  const location = useLocation();
  
  const renderPage = () => {
    switch (location.pathname) {
      case '/docs':
        return <Introduction />;
      case '/docs/quick-start':
        return <QuickStart />;
      case '/docs/contract-addresses':
        return <ContractAddresses />;
      case '/docs/mavrk-locker':
        return <MavrkLocker />;
      case '/docs/token-trading':
        return <TokenTrading />;
      case '/docs/token-locker':
        return <TokenLocker />;
      case '/docs/bridge-operations':
        return <BridgeOperations />;
      case '/docs/wallet-management':
        return <WalletManagement />;
      case '/docs/tydro-leveraged-trading':
        return <TydroLeveragedTrading />;
      case '/docs/terms-and-conditions':
        return <TermsAndConditions />;
      default:
        return <Introduction />;
    }
  };

  return renderPage();
};

export default DocsRouter;
